module.exports = __webpack_public_path__ + "assets/20e7f127419a84fbeda766198792df06.mp3";